<template>
    <div class="p-grid p-fluid p-justify-between">
        <div v-if="organizationHierarchyDepth > 1" :class="structureTreeClass">
            <Article :title="$t('organization')">
                <Tree style="border: 0"
                      selectionMode="single"
                      :value="nodes"
                      :expandedKeys="expandedKeys"
                      :selectionKeys.sync="selectedKey"
                      :metaKeySelection="false"
                      @node-select="onNodeSelect"
                      @node-unselect="onNodeUnselect"/>
            </Article>
        </div>
        <ProgressSpinner v-if="loading"
                       stroke-width="1"
                       style="position: fixed; width: 250px; height: 250px; top: 30%; left: 50%;"/>
        <div v-else class="p-col">
            <Profile :organization.sync="organization" :is-admin="isAdmin" v-if="organization"/>
        </div>
    </div>
</template>

<script>
    import OrganizationService from '@/service/OrganizationService';
    import Profile from '@/components/Organization/Profile';
    import jwtDecode from "jwt-decode";
    import {JwtToken} from "@/utils/jwt";

    export default {
        components: {
            Profile
        },
        data() {
            return {
                loading: true,
                isAdmin: false,
                organization: {
                    associates: []
                },
                nodes: null,
                expandedKeys: {},
                selectedKey: {},
                organizationKeyTheUserBelongsTo: null,
                longestOrganizationName: 0,
                organizationHierarchyDepth: 0,
            }
        },
        service: null,
        created() {
            this.service = new OrganizationService();
        },
        mounted() {
            this.service.getOrganizationTree()
                .then(response => response.data)
                .then(organizations => this.toTreeView(organizations))
                .then(organizationTree => {
                    this.nodes = organizationTree;

                    const node = this.findCurrentOrganizationNode(this.nodes);

                    this.expandNode(node);

                    this.service.getAssociates(node.data.id)
                        .then(result => result.data)
                        .then(associates => {
                            node.data.associates = associates;
                            this.organization = node.data;
                            this.loading = false;
                            this.$route.params.id || this.$router.push({name: this.$route.name, params: {id: node.data.id.toString()}});
                        })
                        .then(() => this.service.getAssociate(this.organization.id, JwtToken.fromLocalStorage().userId())
                        .then(response => response.data.role === 'Admin')
                        .then(isAdmin => this.isAdmin = isAdmin)
                  );
                });
        },
        methods: {
            findCurrentOrganizationNode(arr) {
                if (!arr) {
                    return;
                }

                let depth = 1;
                let queue = [...arr];
                let nextLevelQueue = [];

                let result = null;

                while (queue.length || nextLevelQueue.length) {

                    if (!queue.length) {
                        depth++;
                        queue = nextLevelQueue;
                        nextLevelQueue = [];
                    }

                    const node = queue.pop();

                    if (node.data.id.toString() === this.tokenDecoded.client_id) {
                        result = node;
                        this.organizationKeyTheUserBelongsTo = node.key;
                        // this.organization = node.data;
                    }

                    if (this.longestOrganizationName < 2 * depth + node.data.name.length) {
                        this.longestOrganizationName = 2 * depth + node.data.name.length;
                    }

                    if (node.children) {
                        nextLevelQueue = nextLevelQueue.concat(node.children);
                    }
                }

                this.organizationHierarchyDepth = depth;

                return result ? result : this.nodes[0];
            },
            expandNode(node) {

                this.selectedKey[node.key] = true;

                const split = node.key.split("-");
                for (let i = 0; i < split.length; i++) {
                    this.expandedKeys[node.key.substring(0, 2 * i + 1).toString()] = true;
                }
            },
            toTreeView(organizations, parentKey) {
                return [...organizations]
                    .sort((one, another) => one.name.localeCompare(another.name))
                    .map((item, index) => {
                        const key = parentKey === undefined ? `${index}` : `${parentKey}-${index}`;
                        return {
                            key: key,
                            label: item.name,
                            data: item,
                            icon: "pi pi-fw pi-briefcase",
                            children: this.toTreeView(item.subsidiaries, key)
                        };
                    });
            },
            onNodeSelect(node) {
                this.loading = true;
                this.service.getAssociates(node.data.id)
                    .then(result => result.data)
                    .then(associates => {
                        this.loading = false;
                        this.organization = node.data;
                        this.$set(this.organization, 'associates', associates);
                        this.expandedKeys[node.key] = true;
                        this.expandedKeys = {...this.expandedKeys};
                        this.$router.push({name: this.$route.name, params: {id: node.data.id.toString()}});
                    });
            },
            onNodeUnselect(node) {
                this.organization = null;
                this.expandedKeys[node.key] = false;
                this.expandedKeys = {...this.expandedKeys};
                this.$router.push({name: this.$route.name});
            }
        },
        computed: {
            tokenDecoded() {
                return jwtDecode(localStorage.getItem('access_token'));
            },
            structureTreeClass() {
                return {
                    'p-col-12': true,
                    'p-lg-6': this.longestOrganizationName < 60,
                    'p-xl-4': this.longestOrganizationName < 40
                };
            }
        },
    }
</script>

<style lang="scss" scoped>
    .p-tree {
        border: 0;
    }

    .underlined {
        border-bottom: 1px solid dimgrey;
    }
</style>
